<div class="modal-container-custom">
  <div class="modal-content-custom uploadModalStyle_1">
    <div class="modal-header">
      <button type="button" class="close" aria-label="Close" id="letterhead-close" (click)="activeModal.close()">
        <span aria-hidden="true">&times;</span>
      </button>
      <h4 class="modal-title enabled-text">Select Letterhead</h4>
    </div>
    <div class="modal-body">
      <app-upload-button #uploadLetterhead id="upload-letterhead" [fileTypes]="fileTypes" componentId="letterhead_file" [uploadType]="'KEY'" (fileAsDataURL)="onFileChange($event)"></app-upload-button>
      <div>
        <div *ngIf="!image_file" class="full-width-panal-box row no-data">
          Please upload a letterhead image.
        </div>
        <div *ngIf="image_file">
          <div class="image-container">
            <img id="letterhead" class="text-center letter-img" height="650" width="560" [src]="image_file">
            <div id="resize-container" class="resize-container"></div>
          </div>

        </div>
      </div>


    </div>
    <div class="modal-footer modal-footer-custom">
      <button  id="letterhead-cancel"  type="button" class="col-md-4 btn btn-outline-normal btn-style-right-1 text-left" (click)="activeModal.close()">Cancel</button>
      <button  id="letterhead-submit" class="col-md-4 btn btn-md btn-style-right-1 btn-success text-left for-icon-right for-right-arrow" (click)="onSubmit()">Upload</button>
    </div>
  </div>
</div>
